module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/dog-900.bedd7be144107533.jpg"+" 900w",
        images: [{path: "https://static.sniffspot.com/packs/img/dog-900.bedd7be144107533.jpg",width: 900,height: 600}],
        src: "https://static.sniffspot.com/packs/img/dog-900.bedd7be144107533.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/dog-900.bedd7be144107533.jpg"},
        
        width: 900,
        height: 600
      }